import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import * as apiUrl from "../../apiUrl";

function AboutAmenities({ data }) {
  const amenities = data.amenities ? JSON.parse(data.amenities) : [];

  return (

    <section className="about-amenities-sec" id="about-amenities-sec">
      <Container fluid>
        <Row className="flex-center about-amenity-row">
          {amenities.map((amenity, index) => (
            <Col md={4} key={index}>
              <div className="about-amenity-card" data-aos="fade-up">
                <div className="about-amenity-img">
                  <img
                    src={`${apiUrl.apiUrl}/${amenity.image}`}
                    className="img-fluid"
                    alt="Marquis Developer in Dubai"
                  />
                </div>
                <div className="about-amenity-content">
                  <p className="common-para whiteColor">
                    {amenity.amenity_description}
                  </p>
                  <h3 className="common-head whiteColor">
                    {" "}
                    {amenity.amenity_name}
                  </h3>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>

  );
}
export default AboutAmenities;
